/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import styled from 'styled-components';
import { Tooltip as _Tooltip } from '@carbon/react';
import { styles } from '@carbon/elements';

export const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;

  svg {
    width: 16px;
    height: 16px;

    &.success {
      fill: var(--cds-support-success);
    }

    &.warning {
      fill: var(--cds-support-warning);
    }

    &.error {
      fill: var(--cds-support-error);
    }

    &.unknown {
      fill: var(--cds-text-helper);
    }
  }

  .cds--inline-loading {
    width: 16px;
    height: 16px;
    margin-inline-end: 0;
  }
`;

export const Tooltip = styled(_Tooltip)`
  .cds--tooltip-content {
    padding: 4px 10px;
    ${styles.bodyCompact01};
  }
`;

export const WarningCount = styled.span`
  margin-left: 0.25rem;
  font-size: var(--cds-body-compact-01-font-size);
`;
